<script>
    import SelectField from "../../../ui_elements/SelectField.svelte";
    export let value;
    export let schwerpunkte;
</script>

<SelectField bind:value id={value} label="Schwerpunkt" width="md:w-1/4">
    <option value={"Hauptstudiengang/-ausbildung"}>Hauptstudiengang/-ausbildung</option>
    {#each schwerpunkte as schwerpunkt, spIndex (schwerpunkt)}
        <option value={spIndex}>{schwerpunkt.studiengang === "" ? schwerpunkt.ausbildung : schwerpunkt.studiengang}</option>
    {/each}
</SelectField>